import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getTypesAlertActionAsync } from '../redux/actions/typeAlertActions'

export const useTypesAlert = () => {
  const { typesAlertState } = useSelector((state: RootState) => state.typeAlert)
  const dispatch = useDispatch()

  const getTypesAlert = () => {
    dispatch(getTypesAlertActionAsync())
  }

  return { typesAlertState, getTypesAlert }
}
